import { Routes } from '@angular/router';

import { adminGuard } from '@app/core/guards/admin.guard';
import { isAnonymous, isAuthenticated } from '@app/core/guards/auth.guard';
import { configGuard, envGuard } from '@app/core/guards/config.guard';
import { termsOfUseCompliantGuard } from '@app/core/guards/terms-of-use-compliant.guard';
import { AppEnvironment } from '@models/app-info.model';

export const routes: Routes = [
  {
    path: 'callback',
    redirectTo: '/thread',
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then((c) => c.LayoutComponent),
    canActivate: [configGuard, isAuthenticated, termsOfUseCompliantGuard],
    loadChildren: () => import('./layout.routes').then((m) => m.routes),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then((c) => c.LoginComponent),
    canActivate: [configGuard, isAnonymous],
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./miscellaneous/terms-of-use/terms-of-use.component').then((c) => c.TermsOfUseComponent),
  },
  {
    path: 'cookies',
    loadComponent: () => import('./miscellaneous/cookies-policy/cookies-policy.component').then((c) => c.CookiesPolicyComponent),
    canActivate: [configGuard],
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./miscellaneous/privacy-policy/privacy-policy.component').then((c) => c.PrivacyPolicyComponent),
    canActivate: [configGuard],
  },
  {
    path: 'mission-roadmap',
    loadComponent: () => import('./miscellaneous/mission-roadmap/mission-roadmap.component').then((c) => c.MissionRoadmapComponent),
    canActivate: [configGuard, envGuard([AppEnvironment.dvp, AppEnvironment.local]), isAuthenticated, adminGuard],
  },
  {
    path: 'errors',
    children: [
      {
        path: '404',
        loadComponent: () => import('./miscellaneous/not-found/not-found.component').then((c) => c.NotFoundComponent),
        canActivate: [configGuard],
      },
      {
        path: '500',
        loadComponent: () => import('./miscellaneous/broken-config/broken-config.component').then((c) => c.BrokenConfigComponent),
      },
    ],
  },
  {
    path: 'help',
    loadComponent: () => import('./miscellaneous/onboarding/onboarding.component').then((c) => c.OnboardingComponent),
    canActivate: [isAuthenticated],
  },
  {
    path: '**',
    redirectTo: '/errors/404',
  },
];
